// extracted by mini-css-extract-plugin
var _1 = "ComponentUsage-moduleComponentUsage__Uf4tm";
var _2 = "ComponentUsage-moduleprop__nhsSq";
export { _1 as "ComponentUsage", _2 as "prop" }
